import { defineComponent as _defineComponent } from 'vue'
import { NewBuyBoxView } from '@/stores/user.store';
import { useUserStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { computed } from 'vue';
import { faTimes, faInfoCircle, faTableCells, faList } from '@fortawesome/free-solid-svg-icons';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { useBuyboxView } from '@/features/buybox/composables/useBuyboxView';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxTypeSwitcher',
  props: {
    additionalContexts: null,
    buyBoxType: null,
    title: null
  },
  emits: ["buyBoxTypeSwitched"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'buyBoxTypeSwitched', payload: { buyBoxType: NewBuyBoxView }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	additionalContexts: SnowplowContext[];
	buyBoxType?: NewBuyBoxView;
	title: TitleDetail;
};





const {
	newBuyboxTooltipAcknowledged,
	setNewBuyboxTooltipAcknowledged,
	newBuyboxView,
	setNewBuyboxView,
	isUserFirstVisit,
	isLoggedIn,
	loggedInNewBuyboxView,
	// OLD BUYBOX EXP
	buyboxExpView,
	setBuyboxExpView,
	buyboxViewExpTooltipAcknowledged,
	setBuyboxViewExpTooltipAcknowledged,
	// OLD BUYBOX EXP
} = useUserStore();

// OLD BUYBOX EXP
const { isBuyboxViewExpActive } = useBuyboxView({ titleObjectType: () => props.title.objectType });
// OLD BUYBOX EXP

const { t } = useI18n();

const buyboxView = computed(() => {
	if (!!props.buyBoxType) {
		return props.buyBoxType;
	}

	// OLD BUYBOX EXP
	if (isBuyboxViewExpActive.value) return buyboxExpView.value;
	// OLD BUYBOX EXP

	if (isLoggedIn.value && (props.title.__typename === 'Season' || props.title.__typename === 'Show')) {
		return loggedInNewBuyboxView.value;
	}

	return newBuyboxView.value;
});

const showTooltip = computed(() => {
	// OLD BUYBOX EXP
	if (isBuyboxViewExpActive.value) {
		return !buyboxViewExpTooltipAcknowledged.value;
	}

	// OLD BUYBOX EXP
	if (isLoggedIn.value) {
		return !newBuyboxTooltipAcknowledged.value;
	}
	return !newBuyboxTooltipAcknowledged.value && isUserFirstVisit.value === false;
});

const handleListClicked = () => {
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.LIST });
	} else {
		handleSetBuyboxView(NewBuyBoxView.LIST);
		handleSetTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.LIST);
};

const handleGridClicked = () => {
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.GRID });
	} else {
		handleSetBuyboxView(NewBuyBoxView.GRID);
		handleSetTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.GRID);
};

function trackToggleEvent(label: NewBuyBoxView) {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_view_clicked', label }, props.additionalContexts);
}

function close() {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_switch_acknowledged' }, props.additionalContexts);
	handleSetTooltipAcknowledged();
}

// OLD BUYBOX EXP
function handleSetBuyboxView(viewType: NewBuyBoxView) {
	if (isBuyboxViewExpActive.value) {
		setBuyboxExpView(viewType);
	} else {
		setNewBuyboxView(viewType);
	}
}

function handleSetTooltipAcknowledged() {
	if (isBuyboxViewExpActive.value) {
		setBuyboxViewExpTooltipAcknowledged();
	} else {
		setNewBuyboxTooltipAcknowledged();
	}
}
// OLD BUYBOX EXP

return { __sfc: true,props, emit, newBuyboxTooltipAcknowledged, setNewBuyboxTooltipAcknowledged, newBuyboxView, setNewBuyboxView, isUserFirstVisit, isLoggedIn, loggedInNewBuyboxView, buyboxExpView, setBuyboxExpView, buyboxViewExpTooltipAcknowledged, setBuyboxViewExpTooltipAcknowledged, isBuyboxViewExpActive, t, buyboxView, showTooltip, handleListClicked, handleGridClicked, trackToggleEvent, close, handleSetBuyboxView, handleSetTooltipAcknowledged, faTimes, faInfoCircle, faTableCells, faList }
}

})